import { useState } from "react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "./ui/dialog";
import { useAuth } from "../context/AuthContext";
import { Loader2 } from "lucide-react";

export const UsernameModal = ({ open }) => {
  const { setUsername } = useAuth();
  const [value, setValue] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await setUsername(value);
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open}>
      <DialogContent data-testid="username-modal" className="max-w-sm border-white/10 bg-[#111114] text-white [&>button]:hidden">
        <DialogTitle className="font-heading text-xl font-black tracking-tight">Pick your username</DialogTitle>
        <DialogDescription className="text-sm text-white/50">
          This is how the community will know you. Choose wisely — it's unique to you.
        </DialogDescription>
        <form onSubmit={submit} className="space-y-3">
          <input
            data-testid="username-input"
            value={value}
            onChange={(e) => setValue(e.target.value)}
            placeholder="e.g. wavey_dave"
            className="w-full rounded-md border border-white/10 bg-black/40 px-3.5 py-2.5 text-sm text-white placeholder-white/25 outline-none focus:border-cyan-500/50"
            required
          />
          {error && <p data-testid="username-error" className="text-xs text-red-400">{error}</p>}
          <button data-testid="username-submit-btn" disabled={busy}
                  className="flex w-full items-center justify-center gap-2 rounded-lg bg-cyan-500 py-2.5 text-sm font-semibold text-black transition-colors duration-200 hover:bg-cyan-400 disabled:opacity-50">
            {busy && <Loader2 className="h-4 w-4 animate-spin" />}
            Claim username
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
